// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"8e9de580","452":"f2e98e07","741":"1a0dab18"}[chunkId] + ".chunk.css";
};